export default "https://cdn-static.gokick.com/assets/b96dd49a95534624185e45ca053b90dd739d9b4e/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";